<ng-container *ngIf="boards$">
    <!-- The async pipe yields null until the boards arrive, and an empty list is still truthy,
         so this else branch is precisely the "still loading" state. -->
    <mat-nav-list *ngIf="boards$| async as boards; else loading"
                  class="list-links">
        <a mat-list-item *ngFor="let board of boards"
           (click)="selectBoard($event, board.board_id)" class="board-name">
            <div class="content-wrap">
                <div class="board-name-text">
                    {{ board.board_name }}
                </div>
                <div class="board-menu-btn" *ngIf="isAnalyticsAdmin">
                    <div>
                        <button mat-button [matMenuTriggerFor]="menu">...</button>
                    </div>
                    <div>
                        <mat-menu #menu="matMenu">
                            <a (click)="demoteBoard($event, board)" class="board-demote">
                                <fa-icon icon="chevron-down" class="mr-4"></fa-icon>
                                <p class="m-0 p-0">Demote</p>
                            </a>
                        </mat-menu>
                    </div>
                </div>
            </div>
        </a>
    </mat-nav-list>
</ng-container>

<ng-template #noItems>
    <mat-nav-list class="no-items">
        <a mat-list-item>
            <div class="d-flex align-items-center justify-content-between">
                <span>
                    {{
                        useBrandivioBranding ? ('No Company Boards found'):('No Pattern Boards found')
                    }}
                </span>
            </div>
        </a>
    </mat-nav-list>
</ng-template>

<ng-template #loading>
    <mat-nav-list class="no-items">
        <a mat-list-item>
            <div class="d-flex align-items-center">
                <mat-progress-spinner
                    class="board-loading-spinner mr-2"
                    diameter="16"
                    strokeWidth="2"
                    mode="indeterminate"
                    color="accent"
                ></mat-progress-spinner>
                <span>Loading boards</span>
            </div>
        </a>
    </mat-nav-list>
</ng-template>
